export const ROUTES = {
  // Public
  HOME: "/",
  ABOUT: "/about",
  SERVICES: "/services",
  SERVICE_AVI: "/services/avi",
  SERVICE_VISA: "/services/visa",
  SERVICE_LOGEMENT: "/services/logement",
  SERVICE_BILLETS: "/services/billets",
  SERVICE_FINANCES: "/services/finances",
  SERVICE_SUPPORT: "/services/support",
  HOW_IT_WORKS: "/comment-ca-marche",
  PRICING: "/tarifs",
  FAQ: "/faq",
  CONTACT: "/contact",
  DEMANDE_AVI: "/contact",
  VERIFY_AVI: "/verifier-avi",
  DESTINATION_FRANCE: "/destinations/france",
  DESTINATION_BELGIQUE: "/destinations/belgique",
  DESTINATION_CANADA: "/destinations/canada",
  DESTINATION_LUXEMBOURG: "/destinations/luxembourg",

  // Legal
  PRIVACY_POLICY: "/politique-confidentialite",
  CGV: "/cgv",

  // Auth
  LOGIN: "/login",
  REGISTER: "/inscription",
  FORGOT_PASSWORD: "/mot-de-passe-oublie",

  // Student portal
  STUDENT_DASHBOARD: "/espace-etudiant",
  STUDENT_DOCUMENTS: "/espace-etudiant/documents",
  STUDENT_ATTESTATIONS: "/espace-etudiant/attestations",
  STUDENT_PROFILE: "/espace-etudiant/profil",
  STUDENT_PROCEDURES: "/espace-etudiant/procedures",
  STUDENT_MESSAGES: "/espace-etudiant/messages",
  STUDENT_NOTIFICATIONS: "/espace-etudiant/notifications",
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
